var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfiniteH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 336,
    viewBox: "0 0 224 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2127_219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.854 1H12.1464C5.99043 1 1 6.35654 1 12.9642V323.036C1 329.643 5.99043 335 12.1464 335H211.854C218.01 335 223 329.643 223 323.036V12.9642C223 6.35654 218.01 1 211.854 1Z",
    fill: "white",
    stroke: "#0B0B0B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2127_219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 25C37 21 42 17 47 17C52 17 57 21 57 27C57 37 37 53 37 57C37 53 17 37 17 27C17 21 22 17 27 17C32 17 37 21 37 25Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M136.808 143C125.587 143 117.117 150.6 112 156.91C106.883 150.6 98.4125 143 87.1917 143C80.5104 143 74.1028 145.634 69.3785 150.322C64.6541 155.011 62 161.37 62 168C62 174.63 64.6541 180.989 69.3785 185.678C74.1028 190.366 80.5104 193 87.1917 193C98.4125 193 106.883 185.4 112 179.09C117.117 185.4 125.587 193 136.808 193C143.49 193 149.897 190.366 154.622 185.678C159.346 180.989 162 174.63 162 168C162 161.37 159.346 155.011 154.622 150.322C149.897 145.634 143.49 143 136.808 143ZM87.1917 180.595C83.8256 180.595 80.5975 179.268 78.2173 176.906C75.8372 174.544 74.5 171.34 74.5 168C74.5 164.66 75.8372 161.456 78.2173 159.094C80.5975 156.732 83.8256 155.405 87.1917 155.405C94.7583 155.405 101.387 162.935 104.746 168C101.387 173.065 94.7583 180.595 87.1917 180.595ZM136.808 180.595C129.242 180.595 122.612 173.065 119.254 168C122.612 162.935 129.254 155.405 136.808 155.405C140.174 155.405 143.403 156.732 145.783 159.094C148.163 161.456 149.5 164.66 149.5 168C149.5 171.34 148.163 174.544 145.783 176.906C143.403 179.268 140.174 180.595 136.808 180.595Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2127_219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187 311C187 315 182 319 177 319C172 319 167 315 167 309C167 299 187 283 187 279C187 283 207 299 207 309C207 315 202 319 197 319C192 319 187 315 187 311Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2127_219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 336,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2127_219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(17 17)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2127_219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "matrix(-1 0 0 -1 207 319)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfiniteH);
export default __webpack_public_path__ + "static/media/InfiniteH.30995cdb090f252c33e90280aefcd6ed.svg";
export { ForwardRef as ReactComponent };